export function isBase64(str) {
  try {
    return atob(str) ? true : false;
  } catch (except) {
    return false;
  }
}

export function base64ToBytes(base64) {
  const binString = atob(base64.replace(/-/g, "+").replace(/_/g, "/"));

  return Uint8Array.from(binString, (m) => m.codePointAt(0));
}

export function bytesToBase64(bytes, urlFormat = false) {
  const binString = Array.from(bytes, (byte) =>
    String.fromCodePoint(byte),
  ).join("");
  const buffer = btoa(binString);

  if (urlFormat) {
    return buffer.replace(/\+/g, "-").replace(/\//g, "_");
  }

  return buffer;
}

export function base64ToText(base64) {
  return new TextDecoder().decode(base64ToBytes(base64));
}

export function textToBase64(text, urlFormat = false) {
  return bytesToBase64(new TextEncoder().encode(text), urlFormat);
}
